import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QRDownloadComponent } from './qrdownload.component';
import {QRDownloadRoutingModule} from './qrdownload-routing.module';



@NgModule({
  declarations: [QRDownloadComponent],
  imports: [
    CommonModule,
    QRDownloadRoutingModule
  ]
})
export class QRDownloadModule { }
